// @flow

import * as React from 'react';

type Props = {
  children: React.Node[],
  className?: string,
  onClick: Function,
  disableRippleOnClick?: boolean,
  disabled?: boolean,
  title?:string,
}

type State = {
  cursorPos: {
    animate: boolean,
    width: number,
    height: number,
    top: number,
    left: number,
  },
}

/**
 * Doesn't work inside a parent with clip-path CSS attribute.
 */

class RippleButton extends React.Component<Props, State> {
  static defaultProps = {
    className: '',
    disableRippleOnClick: false,
    disabled: false,
  };

  state: State = {
    cursorPos: {
      animate: false,
      width: 0,
      height: 0,
      top: 0,
      left: 0,
    },
  };

  ref: ?HTMLDivElement;

  reppling = (cursorPos: Object) => {
    // Get the element
    if (!this.ref) {
      return;
    }
    const ripple: HTMLDivElement = this.ref;
    // $FlowFixMe
    const button: HTMLElement = ripple.parentElement;

    const buttonPos = button.getBoundingClientRect();

    const buttonWidth = button.offsetWidth;
    const buttonHeight = button.offsetHeight;

    // Make a Square Ripple
    const rippleWidthShouldBe = Math.max(buttonHeight, buttonWidth);
    const rippleHeigthShouldBe = Math.max(buttonHeight, buttonWidth);

    // Make Ripple Position to be center
    const centerize = rippleWidthShouldBe / 2;

    this.setState({
      cursorPos: {
        animate: true,
        width: rippleWidthShouldBe,
        height: rippleHeigthShouldBe,
        top: cursorPos.top - buttonPos.top - centerize,
        left: cursorPos.left - buttonPos.left - centerize,
      },
    });
  };

  updateRipple = (e: EventHandler) => {
    const cursorPos = {
      top: e.clientY,
      left: e.clientX,
    };
    if (this.state.cursorPos.animate) {
      this.setState({ cursorPos: { ...this.state.cursorPos, animate: false } }, () => {
        this.reppling(cursorPos);
      });
    } else {
      this.reppling(cursorPos);
    }
  };

  render() {
    return (
      <button
        disabled={this.props.disabled}
        onMouseDown={this.updateRipple}
        onTouchStart={this.updateRipple}
        onClick={() => {
          this.props.onClick();
          this.setState({
            cursorPos: { ...this.state.cursorPos, animate: !this.props.disableRippleOnClick },
          });
        }}
        className={`ripple-button${this.props.disabled ? ' disabled' : ''} ${this.props.className || ''}`}
        title={this.props.title}
      >
        {this.props.children}
        <div
          className={`ripple ${this.state.cursorPos.animate ? 'is-reppling' : ''}`}
          ref={(ref: ?HTMLDivElement) => {
            this.ref = ref;
          }}
          style={{
            top: `${this.state.cursorPos.top}px`,
            left: `${this.state.cursorPos.left}px`,
            width: `${this.state.cursorPos.width}px`,
            height: `${this.state.cursorPos.height}px`,
          }}
        />
      </button>
    );
  }
}

export default RippleButton;
